<app-list-module-table
  variant="surface"
  [columns]="columns"
  [rows]="rows"
  [loading]="loading"
  [emptyMessage]="emptyMessage"
  [sortColumn]="sortColumn"
  [sortDirection]="sortDirection"
  (sortChange)="sortChange.emit($event)"
  rowTrackKey="id"
>
  <ng-template listCellDef="id" let-row="row">
    @if (view === 'active' && (P.TENANT_VIEW | hasPermission)) {
      @if (clientDetailRoute(row); as detailLink) {
        <a [routerLink]="detailLink" class="text-primary hover:underline">{{ row.unique_id || '—' }}</a>
      } @else {
        <button
          type="button"
          class="cursor-pointer border-0 bg-transparent p-0 font-mono text-xs text-primary hover:underline"
          (click)="viewDetail.emit(row)"
        >
          {{ row.unique_id || '—' }}
        </button>
      }
    } @else {
      <span class="font-mono text-xs">{{ row.unique_id || '—' }}</span>
    }
  </ng-template>

  <ng-template listCellDef="client" let-row="row">
    @if (view === 'active' && (P.TENANT_VIEW | hasPermission)) {
      @if (clientDetailRoute(row); as detailLink) {
      <a [routerLink]="detailLink" class="flex w-max items-center rounded-lg hover:opacity-90">
        <div class="flex h-8 w-[4.75rem] shrink-0 items-center justify-center ltr:mr-2 rtl:ml-2">
          @if (row.logo) {
          <img [src]="row.logo" class="max-h-7 max-w-full object-contain" [alt]="row.tenant_name || 'Client logo'" />
          } @else if (row.tenant_name) {
          <div class="grid h-8 w-8 place-content-center rounded-full bg-primary text-sm font-semibold text-white">
            {{ initials(row.tenant_name) }}
          </div>
          } @else {
          <div class="grid h-8 w-8 place-content-center rounded-full border border-gray-300 dark:border-gray-800">
            <icon-user class="h-4.5 w-4.5" />
          </div>
          }
        </div>
        <div class="min-w-0 text-left">
          <span class="font-bold text-primary hover:underline dark:text-white">
            {{ row.tenant_name || '—' }}
          </span>
          @if (row.tenant_subdomain) {
          <div class="text-xs text-gray-500 dark:text-gray-400">{{ row.tenant_subdomain }}</div>
          }
        </div>
      </a>
      } @else {
      <button
        type="button"
        class="flex w-max cursor-pointer items-center rounded-lg border-0 bg-transparent p-0 text-left hover:opacity-90"
        (click)="viewDetail.emit(row)"
      >
        <div class="flex h-8 w-[4.75rem] shrink-0 items-center justify-center ltr:mr-2 rtl:ml-2">
          @if (row.logo) {
          <img [src]="row.logo" class="max-h-7 max-w-full object-contain" [alt]="row.tenant_name || 'Client logo'" />
          } @else if (row.tenant_name) {
          <div class="grid h-8 w-8 place-content-center rounded-full bg-primary text-sm font-semibold text-white">
            {{ initials(row.tenant_name) }}
          </div>
          } @else {
          <div class="grid h-8 w-8 place-content-center rounded-full border border-gray-300 dark:border-gray-800">
            <icon-user class="h-4.5 w-4.5" />
          </div>
          }
        </div>
        <div class="min-w-0">
          <span class="font-bold text-primary hover:underline dark:text-white">
            {{ row.tenant_name || '—' }}
          </span>
          @if (row.tenant_subdomain) {
          <div class="text-xs text-gray-500 dark:text-gray-400">{{ row.tenant_subdomain }}</div>
          }
        </div>
      </button>
      }
    } @else {
    <div class="flex w-max items-center">
      <div class="flex h-8 w-[4.75rem] shrink-0 items-center justify-center ltr:mr-2 rtl:ml-2">
        @if (row.logo) {
        <img [src]="row.logo" class="max-h-7 max-w-full object-contain" [alt]="row.tenant_name || 'Client logo'" />
        } @else if (row.tenant_name) {
        <div class="grid h-8 w-8 place-content-center rounded-full bg-primary text-sm font-semibold text-white">
          {{ initials(row.tenant_name) }}
        </div>
        } @else {
        <div class="grid h-8 w-8 place-content-center rounded-full border border-gray-300 dark:border-gray-800">
          <icon-user class="h-4.5 w-4.5" />
        </div>
        }
      </div>
      <div class="min-w-0">
        <div class="font-bold text-primary dark:text-white">{{ row.tenant_name || '—' }}</div>
        @if (row.tenant_subdomain) {
        <div class="text-xs text-gray-500 dark:text-gray-400">{{ row.tenant_subdomain }}</div>
        }
      </div>
    </div>
    }
  </ng-template>

  <ng-template listCellDef="contact" let-row="row">
    {{ row.contact_person || '—' }}
  </ng-template>

  <ng-template listCellDef="phone" let-row="row">
    {{
      row.contact_number
        | tenantPhone : row.contact_number_country_code : row.contact_number_country_iso
    }}
  </ng-template>

  <ng-template listCellDef="email" let-row="row">
    {{ row.email || '—' }}
  </ng-template>

  <ng-template listCellDef="date" let-row="row">
    @if (view === 'deleted') {
    {{ deletedAt(row) | appDate }}
    } @else {
    {{ row.created_at | appDate }}
    }
  </ng-template>

  <ng-template listCellDef="status" let-row="row">
    <div
      class="inline-flex items-center rounded-full py-1 px-3"
      [ngClass]="statusBadgeClass(row.status)"
    >
      {{ row.status === 'InActive' ? 'Inactive' : row.status }}
    </div>
  </ng-template>

  <ng-template listCellDef="actions" let-row="row" let-i="index">
    <div class="agent-action-menu relative inline-flex justify-end">
      <button
        type="button"
        class="rounded-lg p-1.5 text-gray-600 hover:bg-black/[0.06] dark:text-gray-400 dark:hover:bg-white/10"
        (click)="toggleMenu.emit({ key: actionMenuRowKey(i), event: $event })"
        [attr.aria-expanded]="openActionMenuKey === actionMenuRowKey(i)"
        aria-haspopup="menu"
        aria-label="Row actions"
      >
        <icon-horizontal-dots class="size-5 rotate-90" />
      </button>
      @if (openActionMenuKey === actionMenuRowKey(i)) {
      <div
        appActionMenuPanel
        class="min-w-[13rem] rounded-xl border border-gray-200 bg-white shadow-lg dark:border-[#191e3a] dark:bg-[#0e1726]"
        role="menu"
        (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
      >
        @if (view === 'active') {
          @if (P.TENANT_VIEW | hasPermission) {
            @if (clientDetailRoute(row); as detailLink) {
              <a
                role="menuitem"
                [routerLink]="detailLink"
                (click)="closeMenu.emit()"
                class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium rounded-t-xl text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5"
              >
                <icon-user class="size-4 shrink-0 text-[#18214d] dark:text-white" />
                View details
              </a>
            } @else {
              <button
                type="button"
                role="menuitem"
                (click)="closeMenu.emit(); viewDetail.emit(row)"
                class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium rounded-t-xl text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5"
              >
                <icon-user class="size-4 shrink-0 text-[#18214d] dark:text-white" />
                View details
              </button>
            }
          }
          @if (P.TENANT_UPDATE | hasPermission) {
            <button
              type="button"
              role="menuitem"
              class="flex w-full items-center gap-3 border-t border-gray-100 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5"
              (click)="closeMenu.emit(); edit.emit(row)"
            >
              <icon-edit class="size-4 shrink-0 text-[#18214d] dark:text-white" />
              Edit
            </button>
          }
          @if (P.TENANT_TOGGLE_STATUS | hasPermission) {
            <button
              type="button"
              role="menuitem"
              class="flex w-full items-center gap-3 border-t border-gray-100 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:border-[#191e3a] dark:text-white-dark dark:hover:bg-white/5"
              (click)="closeMenu.emit(); toggleStatus.emit(row)"
            >
              <icon-refresh class="size-4 shrink-0 text-[#18214d] dark:text-white" />
              {{ row.status === 'Active' ? 'Deactivate' : 'Activate' }}
            </button>
          }
          @if (P.TENANT_DELETE | hasPermission) {
            <button
              type="button"
              role="menuitem"
              class="flex w-full items-center gap-3 border-t border-gray-100 px-3 py-2.5 text-left text-xs font-medium text-danger hover:bg-gray-50 dark:border-[#191e3a] dark:hover:bg-white/5"
              (click)="closeMenu.emit(); delete.emit(row)"
            >
              <icon-trash-lines class="size-4 shrink-0 text-danger" />
              Delete
            </button>
          }
          @if (P.TENANT_RESEND_LINK | hasPermission) {
            <button
              type="button"
              role="menuitem"
              class="flex w-full items-center gap-3 border-t border-gray-100 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:border-[#191e3a] dark:text-white-dark dark:hover:bg-white/5"
              (click)="closeMenu.emit(); resend.emit(row)"
            >
              <icon-mail class="size-4 shrink-0 text-[#18214d] dark:text-white" />
              Resend link
            </button>
          }
          @if (P.TENANT_APPLY_MIGRATION | hasPermission) {
            <button
              type="button"
              role="menuitem"
              class="flex w-full items-center gap-3 border-t border-gray-100 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:border-[#191e3a] dark:text-white-dark dark:hover:bg-white/5"
              (click)="closeMenu.emit(); applyMigration.emit(row)"
            >
              <icon-cloud-download class="size-4 shrink-0 text-[#18214d] dark:text-white" />
              Apply migration
            </button>
          }
          @if (P.TENANT_APPLY_SEEDER | hasPermission) {
            <button
              type="button"
              role="menuitem"
              class="flex w-full items-center gap-3 border-t border-gray-100 px-3 py-2.5 text-left text-xs font-medium rounded-b-xl text-[#18214d] hover:bg-gray-50 dark:border-[#191e3a] dark:text-white-dark dark:hover:bg-white/5"
              (click)="closeMenu.emit(); applySeeder.emit(row)"
            >
              <icon-dollar-sign-circle class="size-4 shrink-0 text-[#18214d] dark:text-white" />
              Apply seeder
            </button>
          }
        } @else {
          @if (P.TENANT_RESTORE | hasPermission) {
          <button
            type="button"
            role="menuitem"
            class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium rounded-t-xl text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5"
            (click)="closeMenu.emit(); restore.emit(row)"
          >
            <icon-restore class="size-4 shrink-0 text-[#18214d] dark:text-white" />
            Restore
          </button>
          }
          @if (P.TENANT_DELETE | hasPermission) {
            <button
              type="button"
              role="menuitem"
              class="flex w-full items-center gap-3 border-t border-gray-100 px-3 py-2.5 text-left text-xs font-medium rounded-b-xl text-danger hover:bg-gray-50 dark:border-[#191e3a] dark:hover:bg-white/5"
              (click)="closeMenu.emit(); permanentDelete.emit(row)"
            >
              <icon-trash-lines class="size-4 shrink-0 text-danger" />
              Delete permanently
            </button>
          }
        }
      </div>
      }
    </div>
  </ng-template>
</app-list-module-table>
